if (customElements.get('product-card')) {
  console.log('product-card');
}

if (!customElements.get('product-card')) {
    class ProductCard extends HTMLElement {

      constructor() {
        super()
        this.handleProductCardSwatchClick();
        this.handlePLPProductCardClick();
      }

      handleInsideLinkClick = (event) => {
        event.preventDefault();
      }

      fetchProduct(event) {

        event.preventDefault();

        //const isWithinSlider = this.closest('fostr-slider') !== null
        const isWithinCartDrawer = this.closest('#CartDrawer') !== null
        const isProductPage = document.body.classList.contains('product')
        const isMobile = window.innerWidth < 750

        /*
        if ((isWithinSlider && isProductPage && isMobile) || (isWithinSlider && isWithinCartDrawer && isMobile)) {
          return
        }
        */

        fetch(event.target.dataset.productUrl + '?view=card-product--swatches')
        .then(response => response.text())
        .then(text => {

          const newHtml = new DOMParser().parseFromString(text, 'text/html').querySelector('product-card').innerHTML;

          if (newHtml !== null) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          }

        })
        .catch(e => {
          console.error(e);
        });

      }

      handleProductCardSwatchClick() {
        const swatches = this.querySelectorAll('product-group product-group-swatch');
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.fetchProduct.bind(this));
          swatch.querySelector('a.product-group--item')?.classList.add('js-load');
          swatch.querySelector('a.product-group--item')?.addEventListener('click', this.handleInsideLinkClick);
        });
      }

      handlePLPProductCardClick() {

        if (!document.body.id.indexOf('collection') &&  !document.body.id.indexOf('search')) {
          return
        }

        const pageNumber = this.getAttribute('data-page')
        const linkEls = this.querySelectorAll('a')

        if (!linkEls) return

        for (let i = 0; i < linkEls.length; i++) {
          const linkEl = linkEls[i]
          this.handlePLPProductCardLinkClick(linkEl, pageNumber)
        }
      }

      handlePLPProductCardLinkClick(linkEl, pageNumber) {

        linkEl.addEventListener('click', (e) => {
          e.preventDefault()

          let newUrl = window.location.href.split('?')
          if (newUrl[1]) {
            newUrl[1] = newUrl[1].replace(/page=[^&]+&?/, '')

            newUrl[1] = newUrl[1].split('#')[0] + '&page=' + pageNumber
            newUrl = newUrl.join('?')
          } else {
            // check if hash and remove
            newUrl = newUrl[0].split('#')[0]
            newUrl = newUrl + '?page=' + pageNumber
          }

          newUrl = newUrl.replace('?&', '?').replace('&&', '&')

          const productId = this.dataset.productId
          // get offset of clicked product card

          const firstProductYOffset = this.getBoundingClientRect().top;

          if (productId) {
            if (window.location.href.includes('#')) {
              // yes, remove the hash
              newUrl = newUrl.split('#')[0]
              // add product id hash
              newUrl = newUrl + '#pid=' + productId + ',y=' + firstProductYOffset

            } else {
              // if no, then add the hash value
              newUrl = newUrl + '#pid=' + productId + ',y=' + firstProductYOffset
            }
          }

          // push new url reset scroll position
          window.history.pushState({ scrollTop: 0 }, '', newUrl)

          // undo e.preventDefault() and follow the link
          window.location.href = linkEl.href
        })
      }
    }

    customElements.define('product-card', ProductCard)
  }
